export function patchDateToJson(): void {
  const dd = (val: number) => {
    val = Math.floor(Math.abs(val));
    return (val < 10 ? '0' : '') + val;
  };

  Date.prototype.toJSON = function () {
    const date = new Date(this.getTime());
    const offset = -date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() + offset);
    return date
      .toISOString()
      .replace('Z', (offset < 0 ? '-' : '+') + dd(offset / 60) + ':' + dd(offset % 60));
  };
}
